import { render, staticRenderFns } from "./planMark.vue?vue&type=template&id=0835333a&scoped=true"
import script from "./planMark.vue?vue&type=script&lang=js"
export * from "./planMark.vue?vue&type=script&lang=js"
import style0 from "./planMark.vue?vue&type=style&index=0&id=0835333a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0835333a",
  null
  
)

export default component.exports